import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Menu, X } from "lucide-react";
import "./LandingPage.css";

const BRAND_LOGO_SRC = "/WhatsApp%20Image%202026-02-25%20at%206.08.01%20AM.jpeg";

export function PublicNavbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!mobileMenuOpen) {
      document.body.style.overflow = "";
      return undefined;
    }

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        setMobileMenuOpen(false);
      }
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [mobileMenuOpen]);

  return (
    <nav className={`lp-navbar ${scrolled ? "scrolled" : ""} ${mobileMenuOpen ? "menu-open" : ""}`}>
      <div className="lp-nav-top-row">
        <Link to="/" className="lp-nav-brand">
          <div className="lp-nav-logo">
            <img
              src={BRAND_LOGO_SRC}
              alt="AI Embroidery Files"
              style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "inherit" }}
            />
          </div>
          <div className="lp-nav-title">
            <span>AI Embroidery</span>
          </div>
        </Link>
        <button
          type="button"
          className="lp-nav-menu-toggle"
          onClick={() => setMobileMenuOpen((prev) => !prev)}
          aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={mobileMenuOpen}
        >
          {mobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
        <div className="lp-nav-actions">
          <Link to="/about" className="lp-nav-link">
            {t("landing.footerAbout")}
          </Link>
          <Link to="/blog" className="lp-nav-link">
            {t("blog.navTitle")}
          </Link>
          <Link to="/signin" className="lp-nav-link">
            {t("landing.login")}
          </Link>
          <Link to="/signup" className="lp-nav-btn lp-nav-btn-primary">
            {t("landing.getStarted")}
          </Link>
        </div>
      </div>

      {mobileMenuOpen && (
        <button
          type="button"
          className="lp-mobile-backdrop"
          aria-label="Close menu backdrop"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}

      <div className={`lp-mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
        <Link to="/about" className="lp-mobile-menu-link">
          {t("landing.footerAbout")}
        </Link>
        <Link to="/blog" className="lp-mobile-menu-link">
          {t("blog.navTitle")}
        </Link>
        <Link to="/signin" className="lp-mobile-menu-link">
          {t("landing.login")}
        </Link>
        <Link to="/signup" className="lp-mobile-menu-btn">
          {t("landing.getStarted")}
        </Link>
      </div>
    </nav>
  );
}

export function PublicFooter() {
  const { t } = useTranslation();

  return (
    <footer className="lp-footer">
      <div className="lp-footer-inner">
        <div className="lp-footer-brand">
          <div className="lp-nav-brand" style={{ textDecoration: "none" }}>
            <div className="lp-nav-logo" style={{ width: 28, height: 28 }}>
              <img
                src={BRAND_LOGO_SRC}
                alt="AI Embroidery Files"
                style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "inherit" }}
              />
            </div>
            <span style={{ fontSize: 14, fontWeight: 700, color: "#9ca3af" }}>
              AI Embroidery
            </span>
          </div>
        </div>
        <div className="lp-footer-links">
          <Link to="/" className="lp-footer-link">{t("landing.footerHome")}</Link>
          <Link to="/about" className="lp-footer-link">{t("landing.footerAbout")}</Link>
          <Link to="/blog" className="lp-footer-link">{t("blog.navTitle")}</Link>
          <Link to="/privacy" className="lp-footer-link">{t("landing.footerPrivacy")}</Link>
        </div>
        <p className="lp-footer-copy">
          &copy; {new Date().getFullYear()} AI Embroidery Files. {t("landing.footerRights")}
        </p>
      </div>
    </footer>
  );
}
